import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useCallback, useState, useMemo, useRef, useEffect, } from "react";
import { createPortal } from "react-dom";
import { useOnResizeParentEffect, useOnResizeEffect, useOnScrollEffect, anchorPosition, } from "./Select/utils";
const NO_OP = () => { };
function useClickAway(cb) {
    const ref = useRef(null);
    const refCb = useRef(cb);
    useLayoutEffect(() => {
        refCb.current = cb;
    });
    useEffect(() => {
        const handler = (e) => {
            const element = ref?.current;
            if (element && !element.contains(e.target)) {
                setTimeout(() => {
                    refCb.current(e);
                }, 0);
            }
        };
        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, []);
    return ref;
}
export function PopOver({ anchorEl, horizontalPosition = "left", verticalPosition = "bottom", horizontalAlignment = "left", verticalAlignment = "top", onPosition, onScroll, children, clickAwayHandler = NO_OP, ...props }) {
    const [popOverContainer, setPopOverContainer] = useState(null);
    const clickAwayRef = useClickAway(clickAwayHandler);
    const position = useCallback(() => {
        if (anchorEl !== null && popOverContainer !== null) {
            if (onPosition === undefined) {
                anchorPosition(anchorEl, popOverContainer, {
                    horizontalPosition,
                    verticalPosition,
                    horizontalAlignment,
                    verticalAlignment,
                });
                return;
            }
            onPosition(anchorEl, popOverContainer);
        }
    }, [
        horizontalPosition,
        verticalPosition,
        horizontalAlignment,
        verticalAlignment,
        anchorEl,
        onPosition,
        popOverContainer,
    ]);
    useOnScrollEffect(anchorEl, onScroll !== undefined
        ? onScroll
        : () => {
        });
    useOnResizeParentEffect(anchorEl, position);
    useOnResizeEffect(popOverContainer, position);
    useLayoutEffect(() => {
        position();
    }, [position, popOverContainer]);
    const popOverElement = useMemo(() => (_jsx("div", { className: "pdpp-react-popoverContainer skapa-focus-portal", ref: setPopOverContainer, ...props, children: _jsx("div", { ref: clickAwayRef, children: children }) })), [children, props]);
    return createPortal(popOverElement, document.body);
}
//# sourceMappingURL=PopOver.js.map